<template>
    <div class="deposito operacao row">
        <!-- <h4>
            {{operacao.Descricao}}
        </h4> -->
        <div class="col-12 col-md-7 sep">

            <table class="info">
                <thead>
                    <th colspan="2">
                        Detalhes do Estorno
                    </th>
                </thead>
                <tbody>
                    <tr>
                        <td>Valor</td>
                        <td class="text-right">R$ {{ formatarDinheiro(valor) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="detalhes col-12 col-md-5">
             <div class="options">
                <p>
                    ID da Transação
                    <strong>
                        {{ transacao }}
                    </strong>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Masker from '@/utils/masker'

    export default {
        props: {
            operacao: {type: Object}
        },


        created() {

            console.log(this.operacao);

        },

        computed: {
            valor() {
                return this.operacao.Valor
            },
            transacao() {
                return this.operacao.id
            },

            boletoUrl() {
                return 'https://faturas.iugu.com/' + this.operacao.Detalhes.Deposito.BoletoId
            },
        },

        methods: {
            formatDocument(doc) {

                if(doc.length > 11) {
                    return Masker.maskCnpj(doc);
                } else {
                    return Masker.maskCpf(doc);
                }
            },
            formatarDinheiro(value) {

                if(value != null){

                    if(typeof value  == "string") value = parseFloat(value)

                    let options = { 
                        minimumFractionDigits: 2, 
                        maximumFractionDigits: 2
                    }

                    return value.toLocaleString('pt-BR', options )
                }

                return 0
            },
        }
    }
</script>

<style lang="scss" scoped>

    @import "../../../assets/styles/iouu/variables";
	@import "../../../assets/styles/iouu/mixins";

    .operacao {
        h4 {
            text-transform: uppercase;
            font-size: 20px;

            @include xs {
                font-size: 14px;
            }
        }

        .detalhes {
            &{
                padding: 0 2rem;

                @include xs {
                    padding: 0 1rem;
                }
            }

            .decription {
                p {
                    &{
                        padding: 0;
                        margin: 0;
                        text-transform: uppercase;
                        padding-top: 1rem;
                        font-size: 16px;

                        @include xs {
                            font-size: 12px;
                            padding-top: 1rem;
                        }
                    }
                }
            }

            .info {
                tr {
                    &{
                        border-color: #ddd;
                    }

                    td {
                        @include xs {
                            font-size: 10px;
                        }
                    }

                    &.tfooter {
                       border-bottom: 0;
                       font-weight: 700;
                    }
                }
            }

            .options {

                p {
                    color: #000;
                }

                .btn {
                    &{
                        display: inline-block;
                        font-weight: 400;
                        text-align: center;
                        white-space: nowrap;
                        vertical-align: middle;
                        user-select: none;
                        border: 1px solid transparent;
                        padding: .75rem .75rem;
                        font-size: 1rem;
                        line-height: 1.25;
                        border-radius: .25rem;
                        transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
                    }

                    img {
                        width: 18px;
                    }

                    &-link {
                        color: #000;
                        font-size: 12px;
                        font-weight: 700;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Wallet/Operacoes/Extorno.vue